import config from "./firebaseServiceConfig";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";
import "firebase/storage";
// import { AUTH_CONFIG } from "../auth0Service/auth0ServiceConfig";

class firebaseService {
	init() {
		if (Object.entries(config).length === 0 && config.constructor === Object) {
			if (process.env.NODE_ENV === "dev") {
				console.warn(
					"Missing Firebase Configuration at src/app/services/firebaseService/firebaseServiceConfig.js"
				);
			}
			return;
		}

		if (firebase.apps.length < 1) {
			firebase.initializeApp(config);
		}
		this.db = firebase.firestore();
		// this.functions = firebase.functions();
		this.functions = firebase.app().functions("asia-northeast3");
		this.storageRef = firebase.storage().ref();
		this.auth = firebase.auth();
		console.log("this.auth: ", this.auth);
	}

	getUserData = (userId) => {
		if (!firebase.apps.length) {
			return;
		}
		return new Promise((resolve, reject) => {
			this.db
				.collection("Admin")
				.doc(userId)
				.get()
				.then((snapshot) => {
					resolve(snapshot.data());
				});
		});
	};

	createAdminData = (user) => {
		if (!firebase.apps.length) {
			return;
		}
		return this.db.collection("Admin").doc(user.uid).set(user);
	};

	onAuthStateChanged = (callback) => {
		if (!this.auth) {
			return;
		}
		this.auth.onAuthStateChanged(callback);
	};

	addPoint = ({ uid, desc, amount }) => {
		return this.functions.httpsCallable("addPoint")({
			id: uid,
			point: Number(amount),
			desc,
			type: "admin",
		});
	};

	uploadImg = async (file) => {
		console.log("file: ", file.name);
		var fileName = Date.now() + "_" + file.name;
		var snapshot = await this.storageRef.child(`uploads/${fileName}`).put(file);
		console.log("snapshot: ", snapshot);
		return (
			"https://firebasestorage.googleapis.com/v0/b/runningman-31b2d.appspot.com/o/uploads%2F" +
			fileName +
			"?alt=media"
		);
	};

	updateUser = (user, type) => {
		console.log("user, type: ", user, type);
		if (!firebase.apps.length) {
			return;
		}
		return this.db.collection(type).doc(user.uid).update(user);
	};

	signOut = () => {
		if (!this.auth) {
			return;
		}
		this.auth.signOut();
	};

	getAnalytics = () => {
		if (!firebase.apps.length) {
			return;
		}
		return this.db.collection("Analytics");
	};
	getDailyAnalytics = () => {
		if (!firebase.apps.length) {
			return;
		}
		return this.db.collection("DailyAnalytics");
	};

	signOut = () => {
		if (!this.auth) {
			return;
		}
		this.auth.signOut();
	};
}

const instance = new firebaseService();

export default instance;
